import React from 'react'

export default function BotonEstado({ estado }) {

    const color = (estado === "Pagada" ? "green-700" : (estado === "Rechazado" ? "red-700": "amber-400"))

    return (
        <button type="button" class={`text-white bg-${color} font-medium rounded-lg text-xs px-2 py-1 text-center flex justify-center items-center w-20`}>
            {estado}
        </button>
    )
}
